import {today} from './TodayDate';

const findStructuredTableRowColor =(debt:any)=> {
    if(today > debt.lastPaymentDate){
        return "text-row-late";
    }
}

export {findStructuredTableRowColor}